import React from 'react';
import { FaCalendar, FaExternalLinkAlt, FaFilePdf } from 'react-icons/fa';
import './ProgramSchedule.css';

const PDFS = [
  {
    filename: 'Technical_Programme_Final.pdf',
    label: 'Technical Programme (Final)',
    url: '/Technical_Programme_Final.pdf',
  },
  {
    filename: 'Oral Presentations Schedule & Abstract ID',
    label: 'Oral Presentations Schedule & Abstract ID',
    url: '/Oral_Presentations_Schedule_and_Abstrat%20ID.pdf',
  },
  {
    filename: 'Poster Presentation Schedule & Abstract ID',
    label: 'Poster Presentation Schedule & Abstract ID',
    url: '/Poster_Presentation_Schedule_and_Abstract%20ID.pdf',
  },
];

const ProgramSchedule = () => {
  return (
    <div className="schedule-page">
      <div className="schedule-page-header">
        <div className="schedule-container">
          <h1 className="schedule-page-title">
            <FaCalendar /> Programme Schedule
          </h1>
          <p className="schedule-page-subtitle">
            Technical Programme for NCAMST 2026
          </p>
        </div>
      </div>

      <div className="schedule-container">
        {PDFS.map((pdf) => (
          <div className="schedule-card-main" key={pdf.url}>
            <div className="schedule-download-bar">
              <div className="schedule-download-info">
                <FaFilePdf className="schedule-pdf-icon" />
                <span>{pdf.label}</span>
              </div>
              <a
                className="schedule-download-btn"
                href={pdf.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaExternalLinkAlt />
                Open in New Tab
              </a>
            </div>

            <div className="schedule-pdf-viewer">
              <iframe
                src={pdf.url}
                title={pdf.label}
                className="schedule-iframe"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgramSchedule;
